export function handleIfDisableCheckAll(grid, props) {
	return (e) => {
		if (props.oneRowSelection) {
			grid.wrapper.find('.cw_grid_check_all').attr('disabled', true);
		}
	};
}
